import { render, staticRenderFns } from "./UnrestrictedEmailField.vue?vue&type=template&id=9edfc30c&"
import script from "./UnrestrictedEmailField.vue?vue&type=script&lang=js&"
export * from "./UnrestrictedEmailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports